export default __webpack_public_path__ + "static/figure1-8112118c31df2ac9a6c7cb9d3c77a605.webp";